export const common = {
    '请求延时': 'Permintaan Tertunda',
    '操作成功': 'Operasi Berhasil',
    '暂无数据': 'Belum Ada Data',
    '请输入': 'Silakan Masukkan',
    'copyok': 'Salin Berhasil',
    'copyerror': 'Salin Gagal',
};

export const tableList = {
    '持仓': 'Posisi',
    '仓位': 'Posisi',
    '跟单交易量': 'Volume Copy Trading',
    '跟单总交易量': 'Total Volume Copy Trading',
    '用户昵称': 'Nama Panggilan Pengguna',
    '当前委托': 'Pesanan Berjalan',
    '当前计划': 'Rencana Berjalan',
    '历史仓位': 'Riwayat Posisi',
    '账单': 'Catatan Keuangan',
    '全部平仓': 'Tutup Semua Posisi',
    '全部撤单': 'Batalkan Semua Pesanan',

    '合约名称': 'Nama Kontrak',
    '创建时间': 'Waktu Dibuat',
    '方向': 'Arah',
    '杠杆': 'Leverage',
    '保证金': 'Margin',
    '开仓价格': 'Harga Open Posisi',
    '开仓均价': 'Harga Rata-rata Open',
    '全仓风险率': 'Rasio Risiko Cross Margin',
    '预估爆仓价': 'Perkiraan Harga Liquidation',
    '收益率': 'Tingkat Pengembalian',
    '平仓价格': 'Harga Close Posisi',
    '预计强平价': 'Perkiraan Harga Likuidasi',
    '持仓数量': 'Jumlah Posisi',
    '张': 'Kontrak',
    风险率: 'Rasio Risiko',
    保证金率: 'Rasio Margin',
    预计止盈价: 'Perkiraan Harga Take Profit',
    预计止损价: 'Perkiraan Harga Stop Loss',
    浮动盈亏: 'Laba Rugi Mengambang',
    平仓盈亏: 'Laba Rugi Realized',
    盈亏: 'Laba Rugi',
    委托数量: 'Jumlah Order',
    委托价格: 'Harga Order',
    成交价格: 'Harga Eksekusi',
    成交均价: 'Harga Rata-rata Eksekusi',
    止盈价: 'Harga Take Profit',
    止损价: 'Harga Stop Loss',
    执行价: 'Harga Eksekusi',
    触发条件: 'Kondisi Trigger',
    操作: 'Operasi',
    手续费: 'Biaya Transaksi',
    平仓类型: 'Tipe Close Posisi',
    类型: 'Tipe',
    数量: 'Jumlah',

    逐仓做多: 'Long Isolated',
    逐仓做空: 'Short Isolated',
    全仓做多: 'Long Cross',
    全仓做空: 'Short Cross',
    永续合约: 'Kontrak Perpetual',

    手动平仓: 'Manual Close',
    市价平仓: 'Market Close',
    限价平仓: 'Limit Close',
    止盈: 'Take Profit',
    止损: 'Stop Loss',
    手动撤销: 'Manual Batalkan',
    自动减仓: 'Auto-Deleveraging',
    强制减仓: 'Forced Reduction',
    强制平仓: 'Liquidation',
    资金不足系统撤单: 'Pembatalan Sistem: Dana Tidak Cukup',
    资金超限系统撤单: 'Pembatalan Sistem: Melebihi Batas Dana',
    撤单: 'Batalkan Order',
    平仓: 'Tutup Posisi',
    更多: 'Lainnya',
    部分平仓: 'Tutup Sebagian Posisi',
    反向开仓: 'Open Posisi Berlawanan',
    加仓: 'Tambah Posisi',
    一键平仓: 'One-Click Close',
    最新价: 'Harga Terkini',
    体验金平仓: 'Tutup dalam 24 Jam',
    下单时间: 'Waktu Order',
    交易类型: 'Jenis Transaksi',
    委托类型: 'Jenis Order',
    成交类型: 'Jenis Eksekusi',
    逐仓平多: 'Tutup Long Isolated',
    逐仓开多: 'Open Long Isolated',
    逐仓平空: 'Tutup Short Isolated',
    逐仓开空: 'Open Short Isolated',
    全仓平多: 'Tutup Long Cross',
    全仓开多: 'Open Long Cross',
    全仓平空: 'Tutup Short Cross',
    全仓开空: 'Open Short Cross',
    可平量为0: 'Jumlah yang Dapat Ditutup adalah 0',
    激活价格: 'Harga Aktivasi',
    状态: 'Status',
    未激活: 'Non-Aktif',
    已激活: 'Aktif',
    回调率: 'Tingkat Callback',
    仓位ID: 'ID Posisi',
};
export const dialog = {
    前往设置: 'Pergi ke Pengaturan',
    提示: 'Peringatan',
    确定: 'Konfirmasi',
    取消: 'Batal',
    确认要全部平仓吗: 'Konfirmasi untuk menutup semua posisi dengan harga pasar dan membatalkan semua pesanan?',
    确认要全部撤单吗: 'Konfirmasi untuk membatalkan semua pesanan?',
    确认要一键平仓吗: 'Konfirmasi one-click close?',
    确认要一键平仓: 'Konfirmasi one-click close dan hentikan hubungan copy trading?',
    确认要市价平仓吗: 'Konfirmasi close dengan harga pasar?',
    确认要限价平仓吗: 'Konfirmasi close dengan harga limit?',
    需先设置总跟单账户: "Harap atur akun copy trading total terlebih dahulu untuk mengaktifkan copy trading",
    加仓: 'Tambah Posisi',
    不能为空: 'Tidak boleh kosong',
    必须为数字值: 'Harus berupa nilai numerik',
    数字不能小于等于0: 'Angka tidak boleh kurang dari atau sama dengan 0',
    请输入正确的杠杆倍数: 'Silakan masukkan kelipatan leverage yang benar',
    无法切换仓位模式: 'Tidak dapat mengganti mode margin',
    当前账户没有权限: 'Akun saat ini tidak memiliki izin',
    swap001: 'Ada posisi terbuka, tidak dapat mengganti mode margin',
    需全部平仓后可重新设置: "Tidak dapat mengubah jumlah dan rasio copy trading saat memegang posisi copy trading. Harap tutup semua posisi terlebih dahulu untuk mengatur ulang",
    按张数: 'Berdasarkan Kontrak',
    按金额: 'Berdasarkan Jumlah',
    按比例: 'Berdasarkan Rasio',
    按价格: 'Berdasarkan Harga',
    张: 'Kontrak',
    预计加仓金额: 'Perkiraan Jumlah Tambahan',
    预计加仓张数: 'Perkiraan Kontrak Tambahan',
    持仓数量: 'Jumlah Posisi',
    开仓价格: 'Harga Open Posisi',
    确认要反向开仓吗: 'Konfirmasi untuk open posisi berlawanan?',
    预计平仓金额: 'Perkiraan Jumlah Close',
    预计平仓比例: 'Perkiraan Rasio Close',
    预计平仓张数: 'Perkiraan Kontrak Close',
    比例不可以大于: 'Rasio tidak boleh lebih besar dari',
    比例不可以小于: 'Rasio tidak boleh lebih kecil dari',
    部分平仓: 'Tutup Sebagian Posisi',
    确认撤单吗: 'Konfirmasi pembatalan order?',
    确认要平仓吗: 'Konfirmasi untuk close posisi?',
    盈亏: 'Laba Rugi',
    当前止损价: 'Harga Stop Loss Saat Ini',
    预估止损价: 'Perkiraan Harga Stop Loss',
    亏损: 'Rugi',
    止损修改: 'Modifikasi Stop Loss',
    止损比例: 'Rasio Stop Loss',
    止损价格: 'Harga Stop Loss',
    当前盈利价: 'Harga Take Profit Saat Ini',
    预估止盈价: 'Perkiraan Harga Take Profit',
    收益: 'Laba',
    止盈修改: 'Modifikasi Take Profit',
    止盈比例: 'Rasio Take Profit',
    止盈价格: 'Harga Take Profit',
    请输入加仓数: 'Silakan masukkan jumlah tambahan',
    请输入金额: 'Silakan masukkan jumlah',
    请输入止盈价格: 'Silakan masukkan harga take profit',
    请输入止盈比例: 'Silakan masukkan rasio take profit',
    请输入止损价格: 'Silakan masukkan harga stop loss',
    请输入止损比例: 'Silakan masukkan rasio stop loss',

    'BTC/USDT账户模式': 'Mode Akun BTC/USDT',
    账户模式: 'Mode Akun',
    调整仓位模式: 'Sesuaikan Mode Margin',
    保证金模式: 'Mode Margin',
    仓位模式: 'Mode Posisi',
    调整保证金模式: 'Penyesuaian mode margin berlaku untuk semua kontrak USDT',
    调整仓位合并模式: 'Penyesuaian mode penggabungan posisi berlaku untuk semua kontrak USDT',
    全仓模式: 'Mode Cross Margin',
    仓位合并: 'Penggabungan Posisi',
    逐仓: 'Isolated',
    全仓: 'Cross',
    合仓: 'Merged',
    分仓: 'Separated',
    swap002:
        'Dalam mode margin terisolasi, pengguna dapat memegang posisi dua arah, dan risiko posisi short dan long dihitung secara independen. Likuidasi hanya akan menyebabkan kerugian pada margin posisi. Saat pengguna menutup posisi secara manual, kerugian dan keuntungan yang dihasilkan oleh posisi short dan long akan segera diselesaikan ke dalam margin posisi yang sesuai.',
    全仓模式下所有仓位将共享合约账户的可用保证金:
        'Dalam mode margin cross, semua posisi akan berbagi margin yang dapat digunakan dari akun kontrak. Jika terjadi likuidasi paksa, semua posisi dan margin yang dapat digunakan mungkin hilang. Harap perhatikan risiko posisi!',
    合仓提示: '',
    分仓提示: '',
    不再提示: 'Jangan Tampilkan Lagi',

    biking合约用户使用协议: 'Perjanjian Pengguna Kontrak Biking',
    综述:
        '<b>1. Ikhtisar</b><br><br>' +
        '<span>' +
        '1.1 Kontrak Perpetual ("Layanan ini") adalah produk derivatif aset virtual yang diluncurkan oleh "Biking". "Biking" bertanggung jawab atas desain, manajemen produk, dan layanan operasi platform trading.' +
        'Untuk menggunakan Kontrak Perpetual "Biking", Anda harus membaca dan mematuhi "Perjanjian Pengguna Kontrak Perpetual Biking" ("Perjanjian ini"). Harap baca dengan cermat dan pahami sepenuhnya semua ketentuan, dan pilih untuk menerima atau tidak menerima perjanjian ini.' +
        '<br><br>' +
        '1.2 Kecuali Anda telah membaca dan menerima semua ketentuan perjanjian ini, Anda tidak berhak menggunakan Kontrak Perpetual "Biking" dan layanannya. Tindakan Anda menerima perjanjian ini serta menggunakan layanan ini dianggap sebagai Anda telah membaca dan menyetujui untuk terikat oleh perjanjian ini.' +
        '</span>' +
        '<br><br>' +
        '<b>2. Kelayakan Menggunakan Layanan Ini</b>' +
        '<br><br>' +
        '<span>2.1 Anda memahami dan mengonfirmasi bahwa:' +
        '<br>' +
        'Anda telah setuju untuk mematuhi "Syarat Layanan Biking", dan Anda memenuhi syarat dan tidak dilarang menggunakan "layanan" yang didefinisikan di dalamnya;' +
        '<br>' +
        'Perjanjian ini tidak bertentangan dengan hukum di negara atau wilayah Anda;' +
        '<br>' +
        'Anda adalah pemilik sah dari aset virtual yang disetorkan ke layanan ini, dan menjamin bahwa sumber aset virtual ini adalah legal.' +
        '<br><br>' +
        '2.2 Anda memahami risiko menggunakan layanan ini, termasuk tetapi tidak terbatas pada:' +
        '<br>' +
        'Tingkat volatilitas harga yang tinggi dari aset virtual dan derivatifnya dapat menyebabkan kerugian signifikan atau total dalam waktu singkat;' +
        '</span>',
    我已阅读并同意上述协议: 'Saya telah membaca dan menyetujui perjanjian di atas',

    调整杠杆: 'Sesuaikan Leverage',
    杠杆倍数: 'Kelipatan Leverage',
    当前杠杆倍数最大可开: 'Kelipatan leverage saat ini maksimal dapat open: ',
    '当前仓位所需保证金：': 'Margin yang dibutuhkan untuk posisi saat ini: ',

    交易单位切换: 'Alih Satuan Trading',
    成交类型切换: 'Alih Jenis Eksekusi',
    限价: 'Limit',
    市价: 'Market',
    数字范围必须在: 'Rangkaian angka harus antara 1 dan 100',
    请输入平仓数: 'Silakan masukkan jumlah close',
    请输入平仓比例: 'Silakan masukkan rasio close',
    请输入整数: 'Silakan masukkan bilangan bulat',
    以当前最优价格交易: 'Trading dengan harga terbaik saat ini',
    请输入格式正确的杠杆倍数: 'Silakan masukkan kelipatan leverage dalam format yang benar',
    杠杆倍数提示: 'Kelipatan leverage saat ini tinggi, harap perhatikan risikonya.',
    下单二次确认: 'Konfirmasi Kedua Order',
    平仓二次确认: 'Konfirmasi Kedua Close Posisi',
    下单确认: 'Konfirmasi Order',
    二次确认不展示: 'Jangan Tampilkan Lagi (Anda dapat mengaktifkannya kembali di "Pengaturan Preferensi")',
    切换交易单位: 'Alih Satuan Trading',
    偏好设置: 'Pengaturan Preferensi',
    仓位止盈止损: 'Take Profit/Stop Loss Posisi',
    移动止盈止损: 'Trailing Take Profit/Stop Loss',
    止盈止损提示:
        'Trailing take profit/stop loss digunakan untuk menutup posisi, mengacu pada strategi order yang diajukan ke pasar ketika pasar bergerak ke arah yang menguntungkan untuk melindungi keuntungan trader. Ketika harga pasar terbaru mencapai harga aktivasi yang ditetapkan, order diaktifkan; ketika harga pasar mencapai (1 ± tingkat callback) dari harga tertinggi (terendah) setelah trader menetapkan strategi ini, order akan terpicu dan dieksekusi pada harga (1 ± tingkat callback) dari harga tertinggi (terendah) tersebut.',
    最新成交价: 'Harga Eksekusi Terbaru',
    设置止盈: 'Atur Take Profit',
    设置止损: 'Atur Stop Loss',
    预计盈利: 'Perkiraan Laba',
    预计亏损: 'Perkiraan Rugi',
    调整保证金: 'Sesuaikan Margin',
    增加: 'Tambah',
    减少: 'Kurangi',
    最大: 'Maksimal',
    当前仓位保证金: 'Margin Posisi Saat Ini',
    最大可增加: 'Maksimal Dapat Ditambah',
    最大可减少: 'Maksimal Dapat Dikurangi',
    调整后参考强评价: 'Referensi Harga Likuidasi setelah Penyesuaian',
    请输入保证金: 'Silakan masukkan margin',
    强平价格: 'Harga Liquidation',
    开仓数量: 'Jumlah Open Posisi',
    计算: 'Hitung',
    计算结果: 'Hasil perhitungan hanya sebagai referensi',
    回调率: 'Tingkat Callback',
    请输入回调率: 'Silakan masukkan tingkat callback',
    仓位数量: 'Jumlah Posisi',
    激活价: 'Harga Aktivasi',
    请输入激活价: 'Silakan masukkan harga aktivasi',
    激活做多提示: 'Arah long perlu lebih tinggi dari harga eksekusi terbaru',
    激活做空提示: 'Arah short perlu lebih rendah dari harga eksekusi terbaru',
};
export const codeInfo = {
    永续合约: 'Perpetual',
    标记价格: 'Mark Price',
    指数价格: 'Index Price',
    指数价格提示:
        'Harga indeks real-time kontrak ini. Harga ini akan berpartisipasi dalam perhitungan perkiraan harga likuidasi posisi pengguna dan mungkin menyimpang dari harga eksekusi terbaru kontrak untuk menghindari manipulasi harga.',
    '24H最高': 'Tertinggi 24H',
    '24H最低': 'Terendah 24H',
    资金费率: 'Tingkat Pendanaan Periode Ini',
    距费用结算: 'Waktu tersisa hingga penyelesaian biaya periode ini',
    我的赠金: 'Bonus Saya',
};
export const panKou = {
    交易深度: 'Kedalaman Pasar',
    实时成交: 'Buku Order',
    张: 'Kontrak',
    保证金: 'Margin',
    价格: 'Harga',
    数量: 'Jumlah',
    时间: 'Waktu',
    累计: 'Akumulasi',
};
export const placeOrder = {
    立即去玩: "Bermain Sekarang",
    全仓: 'Cross',
    逐仓: 'Isolated',
    杠杆: 'Leverage',
    开多: 'Long',
    开空: 'Short',
    市价委托: 'Market',
    限价委托: 'Limit',
    计划委托: 'Plan',
    价格: 'Harga',
    数量: 'Jumlah',
    限价: 'Limit',
    市价: 'Market',
    止盈止损: 'TP/SL',
    张: 'Kontrak',
    开仓价: 'Harga Open',
    触发价: 'Harga Trigger',
    执行价: 'Harga Eksekusi',

    收益: 'Laba',
    按比例设置: 'Atur Berdasarkan Rasio',
    按价格设置: 'Atur Berdasarkan Harga',
    亏损: 'Rugi',

    swap003: 'Beli/Long',
    swap004: 'Jual/Short',
    买入: 'Beli',
    卖出: 'Jual',
    做多: 'Long',
    做空: 'Short',
    可用: 'Tersedia',
    可做多: 'Dapat Long',
    可做空: 'Dapat Short',

    资产: 'Aset',
    持仓保证金: 'Margin Posisi',
    未实现盈亏: 'Laba Rugi Mengambang',
    净值: 'Equity',
    可用保证金: 'Margin Tersedia',
    账户余额: 'Saldo Akun',
    风险率: 'Rasio Risiko',

    合约信息: 'Info Kontrak',
    指数来源: 'Sumber Indeks',
    合约面值: 'Nilai Nominal Kontrak',
    资金费率: 'Tingkat Pendanaan',
    最大杠杆: 'Leverage Maksimum',
    下单方向可开张数的: ' dari jumlah kontrak yang dapat dibuka untuk arah order',

    立即注册: 'Daftar',
    登录: 'Login',
    swap005: 'Aset (Kontrak Perpetual)',
    登录以查看: 'Login untuk Melihat',

    请输入数量: 'Silakan masukkan jumlah',
    请输入价格: 'Silakan masukkan harga',
    请输入限价: 'Silakan masukkan harga limit',
    请输入止盈止损: 'Silakan masukkan TP/SL',
    '止损率不能大于90%': 'Rasio stop loss tidak boleh lebih besar dari 90%',
    止损价格不能大于: 'Harga stop loss tidak boleh lebih besar dari',
    开通合约账号: 'Buka Akun Kontrak',
    账号冻结: 'Akun Dibekukan',
    '止盈率不能大于1000%': 'Rasio take profit tidak boleh lebih besar dari 1000%',
    请输入触发价: 'Silakan masukkan harga trigger',
    保证金: 'Margin',
    体验金: 'Dana Experiential',
    不使用体验金: 'Tidak Gunakan Dana Experiential',
    查看详情: 'Lihat Detail',
    委托保证金: 'Margin Order',
    币: 'Koin',
    计算器: 'Kalkulator',
    划转: 'Transfer'
};
export const codelist = {
    搜索: 'Cari',
    全部: 'Semua',
    交易对: 'Pair Trading',
    最新价: 'Harga Terkini',
    涨幅: 'Perubahan',
    自选: 'Favorit',
    添加自选成功: 'Ditambahkan ke Favorit',
    取消自选成功: 'Dihapus dari Favorit',
};
export const merchandiser = {
    我的实盘: "Akun Real Saya",
    与优秀的交易员共同赚钱: "Hasilkan Uang Bersama Trader Terbaik",
    code_00051: "Komunitas Copy Trading",
    个人中心: 'Pusat Pengguna',
    更多服务: 'Layanan Lainnya',
    钱包: "Dompet",
    衍生品: 'Derivatif',
    跟单设置: 'Pengaturan Copy Trading',
    跟单: 'Copy Trading',
    跟单提示: 'Data diperbarui setiap jam',
    我的跟单: 'Copy Trading Saya',
    成为交易员: 'Jadi Trader',
    综合排名: 'Peringkat Komprehensif',
    收益率: 'Tingkat Pengembalian',
    近3周收益: 'Pendapatan 3 Minggu Terakhir',
    近3周胜率: 'Win Rate 3 Minggu Terakhir',
    总收益: 'Total Pendapatan',
    累计收益率: 'Tingkat Pengembalian Kumulatif',
    累计跟随人数: 'Total Pengikut Kumulatif',
    跟随中: 'Sedang Diikuti',
    AUM: 'AUM',
    当前跟谁: 'Sedang Mengikuti Siapa',
    搜索交易员: 'Cari Trader',
    满员: 'Penuh',
    申请成为交易员: 'Ajukan Jadi Trader',
    手机号: 'Nomor Ponsel',
    邮箱: 'Email',
    请输入邮箱: 'Silakan masukkan email',
    邮箱错误: 'Silakan masukkan email yang benar',
    请输入手机号: 'Silakan masukkan nomor ponsel',
    手机号错误: 'Silakan masukkan nomor ponsel yang benar',
    请输入正确数值: 'Silakan masukkan jumlah yang benar',
    申请交易员提示文案: 'Ajukan menjadi trader untuk mendapatkan bagi hasil keuntungan',
    跟单确认: 'Konfirmasi Copy Trading',
    我已同意跟单协议: 'Saya telah membaca dan menyetujui perjanjian copy trading',
    跟单协议: '《Perjanjian Copy Trading》',
    申请跟单提示文案: "Perjanjian ini ditetapkan antara Anda (selanjutnya disebut sebagai \"Anda\" atau \"Milik Anda\") dan BiKing. Anda mengakses, menggunakan, atau layanan apa pun yang disediakan oleh platform BiKing atau salah satu situs web di bawahnya (wang.com), aplikasi seluler, atau layanan terkait lainnya yang disediakan oleh situs web lembaga afiliasi BiKing atau salah satu di bawahnya (selanjutnya secara kolektif disebut sebagai \"Layanan ini\"), yang berarti Anda mengonfirmasi telah membaca, memahami, dan menerima semua ketentuan dan kondisi yang ditetapkan dalam perjanjian syarat penggunaan ini (selanjutnya disebut sebagai \"Syarat Penggunaan ini\"), serta pernyataan privasi yang kami umumkan di platform. Selain itu, saat menggunakan beberapa fungsi Layanan ini, Anda mungkin juga harus mematuhi ketentuan dan kondisi tambahan yang berlaku untuk fungsi-fungsi tersebut.",
    申请跟单提示文案1: "1. Mengikuti trader untuk open posisi memiliki risiko kerugian. Risiko ini ditanggung sendiri oleh pengguna yang mengikuti;",
    申请跟单提示文案2: "2. Platform BiKing mendukung follower menggunakan akun copy trading mode margin terisolasi untuk copy trading. Jika follower ingin open posisi secara mandiri, mereka dapat pergi ke kontrak untuk menggunakan akun kontrak untuk trading kontrak, periode ini akun copy trading tidak terpengaruh.",
    申请跟单提示文案3: "3. Setelah berhasil mengikuti, hanya posisi baru yang dibuka oleh trader yang akan diikuti, posisi yang sudah dipegang tidak diikuti; Anda dapat membatalkan copy trading kapan saja, membatalkan copy trading tidak akan menutup order yang sudah diikuti, Anda dapat memilih untuk menutupnya secara manual;",
    申请跟单提示文案4: "4. Selama copy trading, menyesuaikan posisi copy trading akan menyebabkan Anda keluar dari mode copy trading;",
    申请跟单提示文案5: "5. Setelah mengikuti trader menutup posisi dan menghasilkan keuntungan, order tersebut akan membagikan 12% dari jumlah keuntungan kepada trader sebagai hadiah.",
    申请跟单提示文案6: "6. Mengikuti trader untuk melakukan order mungkin memiliki risiko kerugian, harap pilih dengan hati-hati, perhatikan kontrol risiko, dan pahami Risiko Copy Trading",
    申请跟单提示文案7: "7. Ketika order trader yang diikuti ditentukan sebagai trading yang melanggar dan status trader dibatalkan, Anda tidak akan dapat mengikuti open posisi baru, posisi yang sudah diikuti tidak terpengaruh, tetapi akan segera keluar dari mode copy trading.",
    申请跟单提示文案8: "8. Trader berhak menghapus pengikut, setelah dihapus, Anda tidak akan dapat mengikuti open posisi baru, posisi yang sudah diikuti tidak terpengaruh.",
    搜索您的国家名或国家区号: 'Cari nama negara atau kode area negara Anda',
    我已同意成为交易员: 'Saya setuju menjadi trader',
    请勾选: 'Silakan centang',
    申请交易员失败提示: 'Anda saat ini sedang dalam copy trading, sementara tidak dapat mengajukan menjadi trader, harap hentikan semua copy trading terlebih dahulu sebelum mengajukan.',
    我知道了: 'Saya Mengerti',
    今日收益: 'Pendapatan Hari Ini',
    累计收益: 'Pendapatan Kumulatif',
    交易员分成: 'Bagi Hasil Trader',
    待结算分成: 'Bagi Hasil Tertunda',
    已结算分成: 'Bagi Hasil Terselesaikan',
    当前跟单: 'Copy Trading Saat Ini',
    历史跟单: 'Riwayat Copy Trading',
    我的交易员: 'Trader Saya',
    编辑: 'Edit',
    平仓均价: 'Harga Rata-rata Close',
    持仓均价: 'Harga Rata-rata Posisi',
    开仓时间: 'Waktu Open Posisi',
    平仓时间: 'Waktu Close Posisi',
    预估暴仓价: 'Perkiraan Harga Liquidation',
    交易员: 'Trader',
    详情: 'Detail',
    仓位ID: 'ID Posisi',
    空位提醒: 'Pengingat Kekosongan',
    空位提醒内容: 'Jumlah follower trader ini sudah penuh, kirim satu kali pengingat ketika status trader tidak penuh',
    当前跟随: 'Sedang Mengikuti',
    跟随人数数据: '{v1}/{v2} Orang',
    跟随人数: 'Jumlah Pengikut',
    总权益: 'Total Equity',
    带单合约: 'Kontrak yang Diikuti',
    交易数据: 'Data Trading',
    交易笔数: 'Jumlah Transaksi',
    盈利笔数: 'Jumlah Transaksi Untung',
    亏损笔数: 'Jumlah Transaksi Rugi',
    扛单比例: 'Rasio Hold',
    平均扛单率: 'Rata-rata Rasio Hold',
    最大扛单率: 'Rasio Hold Maksimum',
    订单: 'Order',
    跟随者: 'Follower',
    跟随者收益: 'Pendapatan Follower',
    跟随用户: 'Pengikut',
    跟随总额: 'Total Mengikuti',
    跟随收益: 'Pendapatan Mengikuti',
    交易员订单本金: 'Modal Order Trader',
    当前带单: 'Sedang Membawa Order',
    历史带单: 'Riwayat Membawa Order',
    跟单数据统计: 'Statistik Data Copy Trading',
    不用了: 'Tidak perlu',
    设置提醒成功: 'Setel Pengingat Berhasil',
    我的带单: 'Order Saya',
    查看主页: 'Lihat Beranda',
    利润分成比例: 'Rasio Bagi Hasil Keuntungan',
    跟随交易员: 'Ikuti Trader',
    仓位类型: 'Jenis Posisi',
    指定杠杆: 'Tentukan Leverage',
    请输入杠杆: 'Silakan masukkan leverage',
    单笔倍率: 'Rasio per Order',
    单笔金额: 'Jumlah per Order',
    固定额度: 'Jumlah Tetap',
    请输入单笔金额1: 'Silakan masukkan jumlah tetap tidak kurang dari 5U',
    请输入单笔金额: 'Silakan masukkan jumlah copy trading per order {v1}～{v2}',
    请输入单笔倍率: 'Silakan masukkan rasio copy trading {v1}～{v2}',
    每次下单折合U: 'Setiap open posisi menginvestasikan margin setara dengan {v1} USDT',
    每次下单倍数: 'Jumlah setiap order adalah {v1} kali jumlah order trader',
    倍率: 'Rasio',
    跟单本金: 'Modal Copy Trading',
    总跟单保证金: 'Total Margin Copy Trading',
    请输入跟单本金: 'Silakan masukkan modal copy trading',
    资产账户: 'Akun Aset {v1} USDT',
    合约账户: 'Akun Kontrak {v1} USDT',
    风险控制: 'Kontrol Risiko',
    设置: 'Atur',
    保存: 'Simpan',
    取消跟随: 'Batalkan Mengikuti',
    移除跟随: 'Hapus Pengikut',
    交易员保证金: 'Margin Trader',
    请输入交易员保证金: 'Silakan masukkan margin trader',
    风险设置提示: 'Setelah modal posisi mengikuti trader ini mencapai nilai ini, tidak akan lagi mengikuti order',
    关闭带单: 'Tutup Layanan Bawa Order',
    我的跟随者: 'Pengikut Saya',
    带单设置: 'Pengaturan Bawa Order',
    预计利润分成: 'Perkiraan Bagi Hasil Keuntungan',
    利润分成: 'Bagi Hasil Keuntungan',
    开启成功: 'Aktifkan Berhasil',
    开启失败: 'Aktifkan Gagal',
    关闭成功: 'Tutup Berhasil',
    关闭失败: 'Tutup Gagal',
    确认取消吗: 'Konfirmasi batalkan mengikuti?',
    条件一: 'Kontrak tidak memiliki posisi, pesanan berjalan, pesanan rencana',
    条件二: 'Saldo yang dapat digunakan akun kontrak >={v} USDT',
    条件三: 'Kontrak tidak memiliki posisi',
    最大回撤: 'Drawdown Maksimum',
    平均持仓时间: 'Rata-rata Waktu Hold',
    正在跟随: 'Sedang Mengikuti',
    历史跟随: 'Riwayat Mengikuti',
    累计跟单: 'Copy Trading Kumulatif',
    累计分成: 'Bagi Hasil Kumulatif',
    笔: 'Transaksi',
    上一页: 'Halaman Sebelumnya',
    下一页: 'Halaman Selanjutnya',
    返回: 'Kembali',
    今日预估收益: 'Perkiraan Pendapatan Hari Ini',
    账户权益: 'Equity Akun',
    将账户权益展示在个人信息页面: 'Tampilkan equity akun di halaman info pribadi',
    带单本金: 'Modal Bawa Order',
    每次开仓均会展示带单本金: 'Setiap open posisi akan menampilkan modal bawa order',
    隐藏挂单价: 'Sembunyikan Harga Order Tertunda',
    带单币对: 'Pair yang Dibawa',
    入住时间: 'Waktu Bergabung',
    保存成功: 'Simpan Berhasil',
    取消成功: 'Batalkan Berhasil',
    设置成功: 'Atur Berhasil',
    跟单合约: 'Kontrak Copy Trading',
    历史委托: 'Riwayat Order',
    成交数量: 'Jumlah Terekseskusi',
    触发时间: 'Waktu Trigger',
    开启带单: 'Aktifkan Bawa Order',
    账户已冻结: 'Akun telah dibekukan, harap hubungi layanan pelanggan',
    审核中: 'Dalam Peninjauan',
    小时: '{v} Jam',
    累计分润: 'Bagi Hasil Kumulatif',
    今日预估分润: 'Perkiraan Bagi Hasil Hari Ini',
    交易协议: '《Perjanjian Trading》',
    带单协议: '《Perjanjian Bawa Order》',
    追加跟单本金: 'Tambahkan Modal Copy Trading',
    提示: 'Peringatan:',
    提示信息: 'Bagi hasil diselesaikan setiap hari mulai pukul 0:00 dan selesai sebelum pukul 1:00, setelah penyelesaian akan secara otomatis dikirim ke akun kontrak Anda; jika Anda memiliki posisi bawa order selama periode penyelesaian, bagi hasil akan diselesaikan pada hari trading berikutnya',
    合约跟单: 'Copy Trading Kontrak',
    跟单文字: 'Hasilkan uang bersama trader top global di Biking',
    查看牛人实盘: 'Lihat Akun Real Trader Hebat',
    捕捉市场信号: 'Tangkap Sinyal Pasar',
    复制高手收益: 'Salin Keuntungan Master',
    跟单指南: 'Panduan Copy Trading',
    跟单广场: 'Plaza Copy Trading',
    跟单总收益: 'Total Pendapatan Copy Trading',
    丰厚分润收入: 'Pendapatan Bagi Hasil yang Melimpah',
    更多平台曝光: 'Eksposur Platform Lebih Banyak',
    专属交易徽章: 'Lencana Trading Eksklusif',
    成为Biking带单交易员: 'Hanya satu langkah untuk menjadi Trader Biking',
    享受Biking带单交易员的独家福利: 'Nikmati manfaat eksklusif sebagai Trader Biking',
    平台奖励: 'Nikmati 12% Bagi Hasil',
    联系方式: 'Kontak',
    简介: 'Profil',
    请输入简介: 'Silakan masukkan profil',
    交易能力证明: 'Bukti Kemampuan Trading (Opsional)',
    选择周期: 'Pilih periode >30 hari kurva tingkat pengembalian, statistik data trading, dll.; jika tidak mengunggah, kami akan secara default meninjau riwayat trading Anda. Maksimal dapat mengunggah 3 gambar, setiap gambar tidak lebih dari 10 MB.',
    我已阅读并同意: 'Saya telah membaca dan menyetujui',
    跟单交易服务条款: '《Syarat Layanan Copy Trading》',
    立即申请: 'Ajukan Sekarang',
    请输入联系方式: 'Silakan masukkan kontak',
    联系方式不正确: 'Kontak tidak benar!',
    邮箱格式不正确: 'Format email tidak benar',
    请输入简介信息: 'Silakan masukkan informasi profil',
    请确认勾选协议: 'Harap konfirmasi centang perjanjian',
    上传头像图片限制: 'Ukuran gambar avatar yang diunggah tidak boleh lebih dari 10MB!',
    最大限制: 'Saat ini batas maksimal unggah 3 file',
    带单交易员招募中: 'Rekrutmen Trader sedang berlangsung, nikmati segera 12% bagi hasil',
    跟单成功: 'Copy Trading Berhasil',
    昵称: 'Nama Panggilan',
    请输入昵称: 'Silakan masukkan nama panggilan',
    申请交易员已提交: 'Aplikasi trader telah dikirim, harap tunggu tinjauan'
};
export const hyy = {
    bkt: "Tidak Buka",
    wqdkt: "Saya Yakin Buka",
    kt12: "1. Sebelum berpartisipasi, Anda harus memahami secara rinci pengetahuan dasar dan risiko terkait trading kontrak mata uang digital serta semua aturan bisnis terkait partisipasi dalam trading derivatif.",
    kt13: "2. Risiko yang disebutkan dalam dokumen peringatan risiko ini hanya bersifat ilustratif dan tidak mencantumkan semua faktor risiko terkait trading derivatif aset digital. Sebelum berinvestasi dalam trading derivatif aset digital, investor juga harus memahami dan menguasai faktor risiko lain yang mungkin ada.",
    kt14: "3. Kami dengan tulus berharap dan menyarankan investor, dari kemampuan menanggung risiko dan kondisi aktual mereka sendiri, untuk memutuskan dengan hati-hati apakah akan berpartisipasi dalam trading kontrak ini, dan mengalokasikan aset digital mereka secara wajar.",
    kt0: "Pengguna yang terhormat:",
    kt1: "Anda belum membuka akun kontrak dan izin trading kontrak, harap baca dengan cermat konten berikut sebelum memutuskan untuk membuka:",
    kt2: "I. Anda melakukan trading di pasar kontrak, jika pergerakan harga pasar tidak menguntungkan Anda menyebabkan margin posisi Anda tidak cukup, Kontrak Perpetual BiKing akan melakukan likuidasi paksa pada posisi Anda sesuai dengan kesepakatan sistem dan mengungkapkan detail likuidasi.",
    kt3: "II. Anda harus membaca dan mematuhi aturan bisnis Kontrak Perpetual BiKing, memahami mekanisme dan prinsip operasi kontrak, dan memahami berbagai risiko pasar.",
    kt4: "IV. Kontrak Perpetual BiKing terhubung ke sistem trading kontrak, laba rugi posisi pengguna berfluktuasi dengan fluktuasi pasar kontrak, ketika kerugian besar, juga akan terjadi likuidasi dalam sistem trading kontrak. Harap pengguna segera memutuskan perilaku trading mereka sendiri berdasarkan pasar kontrak, menanggung untung dan rugi sendiri, sesuai dengan ini, BiKing tidak bertanggung jawab atas jaminan yang disimpulkan atau ditetapkan.",
    kt5: "V. Dalam beberapa kondisi pasar yang ekstrem, Anda mungkin mengalami kesulitan atau tidak dapat menutup posisi terbuka yang Anda pegang. Misalnya, ketika keuntungan Anda berada di peringkat pertama dalam PnL leverage efektif seluruh pasar kontrak, dan pihak lawan memiliki kerugian yang tidak cukup ditutup oleh dana asuransi.",
    kt6: "VI. Trading derivatif aset digital mungkin menghadapi risiko pengawasan kebijakan dalam yurisdiksi tertentu, Anda harus membuat penilaian dengan hati-hati dengan memahami latar belakang pengawasan kebijakan wilayah trading sebelum trading. Karena perubahan hukum, peraturan, kebijakan di negara dan wilayah terkait, modifikasi aturan trading bursa kontrak, penerapan langkah-langkah darurat, dll., BiKing akan mengungkapkan pernyataan sebelumnya, posisi terbuka yang Anda pegang mungkin tidak dapat terus dipegang, tetapi sisa margin dan keuntungan masih akan direalisasikan.",
    kt7: "VII. Karena alasan yang tidak dapat dikendalikan oleh pihak platform, seperti: force majeure seperti gempa bumi, banjir, kebakaran, atau kegagalan sistem komputer, sistem komunikasi, dll., mungkin menyebabkan instruksi Anda tidak dapat dieksekusi atau tidak dapat dieksekusi seluruhnya, kerugian yang diakibatkannya mungkin harus ditanggung sendiri oleh Anda.",
    kt8: "VIII. Trading \"lindung nilai\" sama seperti trading spekulatif, juga menghadapi risiko yang disebabkan oleh fluktuasi harga.",
    kta9: "IX. Jika Anda belum melakukan verifikasi identitas atau belum mengikat verifikasi Google, atau meminjamkan akun kepada orang lain untuk dioperasikan, mungkin akan memengaruhi keamanan margin kontrak Anda.",
    kta10:
        "III. Dalam beberapa kondisi pasar yang ekstrem, Anda mungkin mengalami kesulitan atau tidak dapat menutup posisi terbuka yang Anda pegang. Misalnya, ketika keuntungan Anda berada di peringkat pertama dalam PnL leverage efektif seluruh pasar kontrak, dan pihak lawan memiliki kerugian yang tidak cukup ditutup oleh dana asuransi.",
    kt9: "Saya telah membaca dengan cermat dan bersedia mengambil risiko",
    kt10: "Buka akun kontrak dan izin trading kontrak",
    zjhz: "Transfer Dana",
    ljhz: "Transfer Sekarang",
    qx: "Batalkan Transfer",
    khz: "Dapat Ditransfer",
    qxz: "Silakan Pilih",
    bz: "Mata Uang",
    c: "Dari",
    zz: "Ke",
    sl: "Jumlah",
    qb: "Semua",
    ktcg: "Buka Berhasil",
    ktsb: "Buka Gagal",
    hzcg: "Transfer Berhasil",
    hzsb: "Transfer Gagal",
    wyyd: "", //Teks peringatan belum dicentang telah dibaca
    tc: "Keluar",
    warning1: "Silakan pilih mata uang",
    warning2: "Akun asal tidak boleh kosong",
    warning3: "Akun tujuan tidak boleh kosong",
    warning4: "Silakan masukkan angka tidak lebih dari jumlah yang dapat ditransfer",
    gb: "Tutup",
    openSuccess: "Anda telah membuka trading kontrak",
    openSuccessTip: "Silakan transfer dana ke akun kontrak",
    warning5: "Pertahankan maksimal 4 desimal",
    not_get_nm: "Maaf, aktivitas chip promo telah berakhir, transfer ini tidak mendapatkan chip promo",
}

export const invite = {
    yqfy: "Undang Dapat Komisi",
    yj1: "Bagikan tautan undangan, poster undangan, atau kode referral",
    yj2: "Undang teman untuk mendaftar dan trading",
    yj3: "Dapatkan komisi biaya transaksi",
    yqm: "Kode Undangan Saya:",
    yqlj: "Tautan Undangan Saya:",
    fz: "Salin",
    fzcg: "Salin Berhasil",
    fzsb: "Salin Gagal",
    dlck: "Login untuk Melihat",
    rs: "Jumlah Orang yang Diundang",
    ljbb: "Komisi Trading Spot Kumulatif ({flag})",
    ljeft: "Komisi Trading ETF Kumulatif ({flag})",
    ljhy: "Komisi Trading Kontrak Kumulatif ({flag})",
    yhm: "Nama Pengguna",
    sfsm: "Apakah Terverifikasi",
    tjsj: "Waktu Referral",
    zsy: "Total Pendapatan ({flag})",
    s: "Ya",
    f: "Tidak",
    djjz: "Klik untuk Memuat Lebih Banyak",
    ckmx: "Lihat Detail",
    pm: "Peringkat",
    zyqr: "Jumlah Undangan Bulanan",
    zfyj: "Jumlah Komisi Bulanan ({flag})",
    ckbd: "Lihat Daftar Lengkap",
    rlues1: "Undang teman, dapatkan komisi jangka panjang, nikmati pendapatan.",
    rlues2:
        "Mengundang teman untuk mendaftar dapat membangun hubungan undangan, teman melakukan trading spot, leverage, ETF dapat mendapatkan komisi biaya transaksi teman, pendapatan komisi undangan tidak terbatas.",
    rlues3: "Aturan & Rasio Komisi Undangan",
    jylx: "Jenis Trading",
    yqrfy: "Komisi Pengundang",
    yqgxyxq: "Masa Berlaku Hubungan Undangan",
    sixMonth: "6 Bulan",
    yj: "Permanen",
    bbjy: "Trading Spot",
    hyjy: "Trading Kontrak",
    etfjy: "Trading Leverage ETF",
    gxsj: "Perbarui data setiap Senin",
    xts: "Tips",
    ts1: "Saat mendaftar, teman harus mengisi kode undangan Anda, baru dianggap sebagai undangan yang berhasil!",
    ts2: "Gunakan ponsel untuk memindai kode QR di sebelah kiri, teruskan tautan kepada pengguna, dapat mengundang pengguna dengan cepat.",
    tgzsy: "Total Pendapatan Promosi ({flag})",
    cz: "Operasi",
    fymx: "Detail Komisi >",
    zwsj: "Belum Ada Catatan",
    yh: "Pengguna",
    hqyj: "Dapatkan Komisi Undangan",
    ysm: "Terverifikasi",
    wsm: "Belum Terverifikasi",
    hyfymx: "Detail Komisi Teman",
    fylx: "Jenis Komisi",
    fyje: "Jumlah Komisi",
    fysj: "Waktu Komisi",
    mxsyb: "Tabel Detail Pendapatan",
    zwjy: "Teman ini belum trading, tidak ada komisi biaya transaksi",
    bczxc: "Simpan ke Album",
    rlues4: "Dipengaruhi oleh fluktuasi jaringan, beberapa pengguna mungkin mengalami penundaan komisi, harap bersabar.",
    moreRules: "Lihat Aturan Detail",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/merchandiser/ba.js